import { apiCall } from './gqlClient';

const GETPROVIDERCUSTOMERSWALLETS_QUERY = `
  query getProviderCustomersWallets {
    getProviderCustomersWallets
    {
      id
			customerId
			providerId
			balance
			created
			startDate
			endDate
			active
      ...fragments
    }
  }`;

export const getProviderCustomersWalletsApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERCUSTOMERSWALLETS_QUERY, variables: {}, fragments });

const GETWALLETEVENTS_QUERY = `
  query getWalletEvents($id: String!) {
    getWalletEvents(id: $id)
    {
      id
			walletId
			amount
			created
			type
      ...fragments
    }
  }`;

export const getWalletEventsApiCall = async ({id}, fragments = null) => apiCall({ query: GETWALLETEVENTS_QUERY, variables: {id}, fragments });

const GETCUSTOMERWALLET_QUERY = `
  query getCustomerWallet($customerId: Int!) {
    getCustomerWallet(customerId: $customerId)
    {
      id
			customerId
			providerId
			balance
			created
			startDate
			endDate
			active
      ...fragments
    }
  }`;

export const getCustomerWalletApiCall = async ({customerId}, fragments = null) => apiCall({ query: GETCUSTOMERWALLET_QUERY, variables: {customerId}, fragments });

const CREATECUSTOMERWALLET_QUERY = `
  mutation createCustomerWallet($request: CustomerWalletInput!) {
    createCustomerWallet(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createCustomerWalletApiCall = async ({request}, fragments = null) => apiCall({ query: CREATECUSTOMERWALLET_QUERY, variables: {request}, fragments });

const CREATECUSTOMERWALLETNOAUTH_QUERY = `
  mutation createCustomerWalletNoAuth($request: CustomerWalletInput!) {
    createCustomerWalletNoAuth(request: $request)
    {
      id
			customerId
			providerId
			balance
			created
			startDate
			endDate
			active
      ...fragments
    }
  }`;

export const createCustomerWalletNoAuthApiCall = async ({request}, fragments = null) => apiCall({ query: CREATECUSTOMERWALLETNOAUTH_QUERY, variables: {request}, fragments });

const UPDATECUSTOMERWALLET_QUERY = `
  mutation updateCustomerWallet($request: CustomerWalletInput!) {
    updateCustomerWallet(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateCustomerWalletApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATECUSTOMERWALLET_QUERY, variables: {request}, fragments });

const CHANGECUSTOMERWALLETSTATUS_QUERY = `
  mutation changeCustomerWalletStatus($id: String!, $status: Boolean!) {
    changeCustomerWalletStatus(id: $id, status: $status)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeCustomerWalletStatusApiCall = async ({id, status}, fragments = null) => apiCall({ query: CHANGECUSTOMERWALLETSTATUS_QUERY, variables: {id, status}, fragments });

const TOPUPWALLET_QUERY = `
  mutation topUpWallet($request: WalletTopupInput!) {
    topUpWallet(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const topUpWalletApiCall = async ({request}, fragments = null) => apiCall({ query: TOPUPWALLET_QUERY, variables: {request}, fragments });

const CREATEWALLETEVENT_QUERY = `
  mutation createWalletEvent($request: WalletEventInput!, $newWallet: Boolean) {
    createWalletEvent(request: $request, newWallet: $newWallet)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createWalletEventApiCall = async ({request, newWallet}, fragments = null) => apiCall({ query: CREATEWALLETEVENT_QUERY, variables: {request, newWallet}, fragments });

const REIMBURSEINTOCUSTOMERWALLET_QUERY = `
  mutation reimburseIntoCustomerWallet($userId: Int!, $providerId: Int!, $amount: Float!, $eventId: Int, $type: String, $orderId: Int, $customerId: Int) {
    reimburseIntoCustomerWallet(userId: $userId, providerId: $providerId, amount: $amount, eventId: $eventId, type: $type, orderId: $orderId, customerId: $customerId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const reimburseIntoCustomerWalletApiCall = async ({userId, providerId, amount, eventId, type, orderId, customerId}, fragments = null) => apiCall({ query: REIMBURSEINTOCUSTOMERWALLET_QUERY, variables: {userId, providerId, amount, eventId, type, orderId, customerId}, fragments });
